import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { LocalStorageService } from '../Service/LocalStorageService';
import { useAppSelector } from '../store/hooks';

const PublicRoutes = () => {
  const authUser = useAppSelector(state => state.user?.user);
  const token = LocalStorageService.getItem('accessToken');

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);

    const adminRoles = ['admin', 'manager'];
    const isAdmin = adminRoles.includes(authUser?.role || '');

    if (token && !isAdmin) {
      setIsLoading(false);
      navigate('/home');
    } else if (token && isAdmin) {
      setIsLoading(false);
      navigate('/admin');
    }

    setIsLoading(false);
  }, [authUser, token]);

  if (isLoading) return <></>;

  return <Outlet />;
};

export default PublicRoutes;
